module.exports = __webpack_public_path__ + "img/cardBg2.e1312935.png";